<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ANraN1/tc-custom/9781488018206.jpg?1734751544883" alt="This image is the cover for the book Soldier and the Single Mom, Rescue River"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Soldier and the Single Mom, Rescue River
      </h1>
      <p class="bookDescription body article font2">
        <b>A widowed veteran and a single mom discover just how healing love can be in this wholesome contemporary Western romance.</b><br/><br/>When Buck Armstrong encounters Gina Patterson and her baby stranded on a dark country road outside town, he intends to help them out—and then keep his distance. Gina and little Bobby remind the handsome veteran too much of all he’s lost. Besides, the vulnerable single mom seems equally wary of getting involved. <br/><br/>Things begin to change once Gina and her son settle into the boardinghouse run by Buck’s sister. Being with Gina and Bobby makes Buck question his plans to leave town for a fresh start. Suddenly he has dreams of forging a new family, even though it will mean risking his heart . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Tobin McClain
      </h2>
      
      <p class="authorDescription body article">Lee Tobin McClain is the <I>New York Times</I> bestselling author of more than thirty novels. A professor-turned-writer, she finds inspiration in her beautiful and brilliant daughter, her goofy goldendoodle, and her aptly named cat, Trouble. Learn more about her books at www.leetobinmcclain.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05b01bb6